"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_ENTITIES = exports.RESET = exports.MUTATE_FAILURE = exports.MUTATE_SUCCESS = exports.MUTATE_START = exports.MUTATE_ASYNC = exports.CANCEL_QUERY = exports.REQUEST_FAILURE = exports.REQUEST_SUCCESS = exports.REQUEST_START = exports.REQUEST_ASYNC = void 0;
var REQUEST_ASYNC = '@@query/REQUEST_ASYNC';
exports.REQUEST_ASYNC = REQUEST_ASYNC;
var REQUEST_START = '@@query/REQUEST_START';
exports.REQUEST_START = REQUEST_START;
var REQUEST_SUCCESS = '@@query/REQUEST_SUCCESS';
exports.REQUEST_SUCCESS = REQUEST_SUCCESS;
var REQUEST_FAILURE = '@@query/REQUEST_FAILURE';
exports.REQUEST_FAILURE = REQUEST_FAILURE;
var CANCEL_QUERY = '@@query/CANCEL_QUERY';
exports.CANCEL_QUERY = CANCEL_QUERY;
var MUTATE_ASYNC = '@@query/MUTATE_ASYNC';
exports.MUTATE_ASYNC = MUTATE_ASYNC;
var MUTATE_START = '@@query/MUTATE_START';
exports.MUTATE_START = MUTATE_START;
var MUTATE_SUCCESS = '@@query/MUTATE_SUCCESS';
exports.MUTATE_SUCCESS = MUTATE_SUCCESS;
var MUTATE_FAILURE = '@@query/MUTATE_FAILURE';
exports.MUTATE_FAILURE = MUTATE_FAILURE;
var RESET = '@@query/RESET';
exports.RESET = RESET;
var UPDATE_ENTITIES = '@@query/UPDATE_ENTITIES';
exports.UPDATE_ENTITIES = UPDATE_ENTITIES;